import { Pipe, PipeTransform } from '@angular/core';

import { MissionMotif } from '@models/mission-motif';

@Pipe({
  name: 'missionMotifLabel',
  standalone: true
})
export class MissionMotifLabelPipe implements PipeTransform {
  transform(code: string, motifs: MissionMotif[]): string {
    if (!code || !motifs) {
      return '';
    }

    return motifs.find(motif => motif.code === code)?.label || '';
  }
}
